<template>
  <div class="classes">
    <div class="classes__list" v-if="$windowWidth < 992">
      <p
          class="classes__text"
          v-for="cl of $store.getters.PROFILE.myClasses"
          v-bind:key="cl.id">
        {{cl.fullName}} {{cl.type == 1 ? 'группа' : 'класс'}}</p>
    </div>
    <div class="classes__desktop-list" v-if="$windowWidth > 992">
      <p
          class="classes__text classes__text_desktop"
          :class="{'classes__text_disabled' : cl.id == 0}"
          v-for="cl of classes"
          v-bind:key="cl.id">
        {{cl.fullName}} {{cl.type == 1 ? 'группа' : 'класс'}}</p>
    </div>
    <div class="classes__container">
      <div class="classes__card card" :class="{'card_max' : isToggle,'card_max_alert' : alertText.length > 0}"
           v-if="this.$store.getters.PROFILE.myClasses.length < 4 && !isSuccess">
        <svg
            class="card__rotate"
            :class="{'card__rotate_inverse' : isToggle}"
            @click="toggle"
            width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="icons/стрелки/расписание/вниз" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M6.22780584,9.23431458 C6.50393412,8.95029691 6.93602979,8.92447712 7.24051579,9.15685521 L7.32774972,9.23431458 L13,15.0682667 L18.6722503,9.23431458 C18.9483786,8.95029691 19.3804742,8.92447712 19.6849602,9.15685521 L19.7721942,9.23431458 C20.0483225,9.51833224 20.073425,9.9627735 19.8475019,10.2759591 L19.7721942,10.3656854 L13.5499719,16.7656854 C13.2738437,17.0497031 12.841748,17.0755229 12.537262,16.8431448 L12.4500281,16.7656854 L6.22780584,10.3656854 C5.92406472,10.053266 5.92406472,9.54673401 6.22780584,9.23431458 Z" id="Path" fill="#788396" fill-rule="nonzero"></path>
          </g>
        </svg>
        <div class="card__body">
          <p class="card__title" :class="{'card__title_max' : isToggle}">{{textTitle}}</p>
          <p class="card__description" v-if="alertText.length === 0">Введите данные с другого ключа</p>
          <AlertText
              class="card__alert"
              :value="alertText"
              v-if="alertText.length > 0"/>
          <InputProfile
              v-model="login"
              class="card__input"
              type="text"
              size="lg"
              placeholder="Введите логин"/>
          <InputProfile
              v-model="password"
              class="card__input"
              type="text"
              size="lg"
              placeholder="Введите пароль"/>
          <div class="card__classes">
            <p class="card__classes-title" v-if="type === 0">Класс</p>
            <p class="card__classes-title" v-if="type === 1">Группа</p>
            <InputProfile
                v-model="digit"
                class="card__classes-input"
                type="text"
                size="sm"
                placeholder="1"/>
            <InputProfile
                v-if="type === 0"
                v-model="letter"
                class="card__classes-input"
                type="text"
                size="sm"
                placeholder="А"/>
          </div>
          <ButtonPink
              value="ДОБАВИТЬ"
              class="card__button"
              size="md"
              @click.native="unionAccounts"/>
        </div>
      </div>
      <div class="classes__card_success" v-if="isSuccess">
        <p class="classes__card_success__title">Поздравляем!</p>
        <p class="classes__card_success__text">Объединение аккаунтов прошло успешно.</p>
        <ButtonPink
            value="ОК"
            class="classes__card_success__button"
            size="md"
            @click.native="$router.push({name: 'ParentDashboard'})"/>
      </div>
      <div class="classes__info"
           v-if="!isSuccess"
           v-show="!isToggle"
           :class="{'classes__info_disabled' : $store.getters.PROFILE.myClasses.length === 4}">
        <svg
            class="classes__icon"
            width="44" height="44" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="49.996%" y1="-122.007%" x2="50%" y2="100%" id="b"><stop stop-color="#FB8697" stop-opacity="0" offset="0%"/><stop stop-color="#FA7D8E" stop-opacity=".16" offset="5.548%"/><stop stop-color="#F54E5E" offset="100%"/></linearGradient><path d="M22 0c12.15 0 22 9.85 22 22s-9.85 22-22 22c-3.773 0-7.324-.95-10.428-2.623C22.843 39.167 31.176 31.329 31.176 22c0-3.299-1.042-6.411-2.886-9.154.514-.162.99-.341 1.428-.538 2.478-1.114 3.642-2.797 3.184-5.087a.332.332 0 0 0-.411-.257l-7.607 2.01c-3.432-3.063-8.051-5.32-13.311-6.351A21.904 21.904 0 0 1 22 0ZM7.562 5.4c5.2.412 9.836 2.11 13.363 4.619l-7.521 1.987c-.994.19-1.962.507-2.872.953-3.237 1.586-5.273 4.58-5.273 7.867l.001.035-.025.323c-.19 2.007-1.102 3.307-1.943 4.257-.542.425-1.655-.22-2.128.415l.653.876.351.468c1.19 1.579 2.556 3.297 3.356 3.707.586-.347 2.068-1.986 3.183-3.351.553.432 1.164.814 1.825 1.138 3.159 1.548 7.024 1.548 10.183 0 3.237-1.587 5.273-4.58 5.273-7.868 0-2.716-1.39-5.23-3.696-6.917a41.288 41.288 0 0 0 2.488-.29c1.988 2.486 3.121 5.36 3.121 8.381 0 8.404-8.773 15.682-20.338 16.6C2.929 34.568 0 28.626 0 22l.001.09a4.271 4.271 0 0 0 .095-2.138A21.94 21.94 0 0 1 7.428 5.518Zm4.235 10.182c2.36-1.157 5.293-1.157 7.653 0 2.281 1.118 3.645 3.123 3.645 5.244 0 2.122-1.364 4.127-3.645 5.245-2.36 1.157-5.293 1.157-7.653 0-2.281-1.118-3.645-3.123-3.645-5.245 0-2.12 1.364-4.126 3.645-5.244Zm3.928.767c-2.616 0-4.738 2.01-4.738 4.49 0 2.478 2.122 4.488 4.738 4.488 2.617 0 4.739-2.01 4.739-4.489s-2.122-4.489-4.739-4.489ZM14.853 18c1.092 0 1.977.992 1.977 2.216 0 1.224-.885 2.216-1.977 2.216s-1.977-.992-1.977-2.216c0-1.224.885-2.216 1.977-2.216Zm-.222 1.538c-.397.087-.69.386-.69.68 0 .29.286.586.676.675-.199-.13-.299-.417-.299-.675 0-.269.095-.561.313-.68Zm.446.002.042.024.076.065c.138.147.2.381.2.589 0 .249-.101.542-.302.675.391-.092.68-.396.68-.675 0-.283-.297-.592-.696-.678Z" id="a"/></defs><g fill="none" fill-rule="evenodd"><circle fill="#FFF" cx="22" cy="22" r="22"/><use fill="url(#b)" xlink:href="#a"/><circle stroke="#F5F5F5" stroke-width="1.44" fill="#1BB157" cx="37.08" cy="37.08" r="3.24"/></g></svg>
        <p class="classes__text-info" v-html="infoText"></p>
      </div>
    </div>
    <warning-union-account-modal v-on:confirm="onConfirmUnion"></warning-union-account-modal>
  </div>
</template>

<script>
import ButtonPink from "../../../components/button/ButtonPink";
import InputProfile from "../../../components/input/InputProfile";
import WarningUnionAccountModal from "../../../components/modal/WarningUnionAccountModal";
import AlertText from "../../../components/alert/AlertText";
export default {
  name: "SettingsClassesView",
  components: {AlertText, WarningUnionAccountModal, ButtonPink, InputProfile},
  data(){
    return {
      isToggle: false,
      isSuccess: false,
      login : "",
      password : "",
      letter: "",
      digit: "",
      alertText : "",
      type: null,
    }
  },
  computed:{
    textTitle(){
      if (this.$store.getters.PROFILE.myClasses[0].type === 0){
        return this.isToggle ? 'Добавление класса' : 'Добавить класс'
      } else {
        return this.isToggle ? 'Добавление группы' : 'Добавить группу'
      }
    },
    classes(){
      const profile = this.$store.getters.PROFILE
      let arr = [{id: 0},{id: 0},{id: 0},{id: 0}]
      if ( profile != null){
        for (let [index,cl] of this.$store.getters.PROFILE.myClasses.entries()){
          arr[index] = cl
        }
      }
      return arr
    },

    infoText(){
       if (this.$store.getters.PROFILE.myClasses.length === 4){
         return "Вы достигли максимального количества учеников в профиле";
       } else {
         //@ts-ignore
         return "Ваши дети учатся в разных <br>группах или классах? <br>Воспользуйтесь функцией объединения аккаунтов и оплачивайте тариф со <strong style='font-weight: 800'>скидкой 50%</strong> на каждый добавленный профиль ребенка";
       }
    },

    isEmpty(){
      return this.login.length === 0 && this.password.length === 0 && this.digit.length === 0 && this.letter.length === 0
    }
  },
  methods:{
    toggle(){
      this.isToggle = !this.isToggle

      if (!this.isToggle){
        this.clear()
      }
    },

    clear(){
      this.alertText = ""
      this.login = ""
      this.password = ""
      this.letter = ""
      this.digit = ""
    },

    async onConfirmUnion(){
      const statusCode = await this.$store.dispatch("UNION_ACCOUNTS",{data : {
          login : this.login,
          password : this.password,
          letter : this.letter,
          digit : this.digit
        }})


      if (statusCode === 200){
        await this.$store.dispatch("UPDATE_LOCAL_PROFILE")

        this.isSuccess = true;
      } else {
        if (statusCode === 403){
          this.alertText = "Нельзя добавить аккаунт с таким статусом"
        } else if (statusCode === 400) {
          this.alertText = "Этот класс уже занесен в ваш профиль"
        } else{
          this.alertText = "Ошибка!<br>Неправильный логин или пароль"
        }
      }
    },


    async unionAccounts(){
      this.isSuccess = false
      if (this.login.length === 0){
        this.alertText = "Ошибка!<br>Неправильный логин или пароль"
      } else if (this.password.length < 6 ){
        this.alertText = "Ошибка!<br>Неправильный логин или пароль"
      } else if ((this.letter.length === 0 || this.digit.length === 0) && this.type === 0){
        this.alertText = "Введите корректный класс"
      } else {
        this.$modal.show("WarningUnionAccountModal")
      }
    },
  },
  async mounted(){
    await this.$store.dispatch("UPDATE_LOCAL_PROFILE")
    this.type = this.$store.getters.PROFILE.myClasses[0].type
  }
}
</script>

<style scoped lang="scss">
.classes{
  display: flex;
  align-items: center;
  flex-direction: column;

  &__container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;

    width: 500px;

    @include media(767){
      width: 345px;
    }
  }

  &__list{
    display: flex;
    margin-left: 7px;
    margin-right: 7px;
    justify-content: center;
    margin-top: 21px;
  }

  &__desktop-list{
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 20px;
    top: 70px;
  }

  &__text{
    width: 80px;
    height: 26px;
    background: #788396;
    border-radius: 13px;
    text-align: center;
    font-family: CodeNext;
    font-weight: bold;
    font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 26px;
    margin-left: 5px;
    margin-right: 5px;

    &_desktop{
      margin-bottom: 10px;
    }

    &_disabled{
      background: rgba(0,0,0,0.05);
      border-radius: 13px;
      color: transparent;

    }

  }

  &__card{
    margin-top: 10px;
    margin-bottom: 20px;
    z-index: 2;


    &_success{
      margin-top: 20px;
      background: #FFFFFF;
      border: 1px solid rgba(198,206,212,0.50);
      border-radius: 6px;
      width: 500px;
      height: 260px;
      padding-left: 100px;

      @include media(767){
        width: 345px;
        height: 230px;
        padding-left: 20px;
      }


      &__title{
        font-family: CodeNext;
        font-weight: 800;
        font-size: 24px;
        color: #222222;
        margin-top: 51px;
      }

      &__text{
        font-family: Roboto, "sans-serif";
        font-weight: 300;
        font-size: 14px;
        color: #333942;
        line-height: 20px;
        margin-top: 7px;
      }

      &__button{
        margin-top: 58px;

        @include media(767){
          margin-top: 38px;
          margin-left: 8px;
        }
      }
    }
  }


  &__info{
    display: flex;
    align-items: flex-end;
    justify-content: start;
    position: absolute;
    top: 94px;
    z-index: 1;
    left: 0;


    &_disabled{
      margin-top: 173px;
    }
  }

  &__text-info{
    margin-left: 11px;
    width: 290px;
    padding: 18px 9px 18px 17px;
    font-family: Roboto, "sans-serif";
    font-weight: 300;
    font-size: 14px;
    color: #333942;
    line-height: 22px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16);
    border-radius: 8px;

    strong{
      font-weight: 800;
    }
  }
}


.card{
  width: 500px;
  height: 64px;
  background: #FFFFFF;
  border: 1px solid rgba(198,206,212,0.50);
  border-radius: 6px;
  overflow: hidden;
  transition: height .3s;
  padding-left: 20px;


  @include media(767){
    width: 345px;
    height: 64px;
    background: #FFFFFF;
    border: 1px solid rgba(198,206,212,0.50);
    border-radius: 6px;
    overflow: hidden;
    transition: height .3s;
    padding-left: 20px;
  }

  &__rotate{
    margin-top: 19px;
    margin-left: 434px;
    transition: transform .3s;
    cursor: pointer;
    &:hover{
      border-radius: 50%;
      background-color: #F4F4F4;
    }

    @include media(992){
      &:hover{
        border-radius: 0;
        background-color: transparent;
      }
    }



    @include media(767){
      margin-left: 279px;

    }
    &_inverse{
      transform: rotate(180deg);
    }
  }

  &_max{
    height: 450px;

    &_alert{
      height: 474px;
    }
  }

  &__body{
    margin-left: 78px;

    @include media(767){
      margin-left: 0px;
    }
  }

  &__title{
    font-family: CodeNext;
    font-weight: bold;
    font-size: 17px;
    color: #383E47;
    letter-spacing: 0;
    text-align: left;
    line-height: 26px;
    margin-top: -29px;
    transition: margin-left .3s, margin-top .3s, font-size .3s;
    margin-left: -78px;


    @include media(767){
      margin-left: 0;
    }

    &_max{
      font-family: CodeNext;
      font-size: 24px;
      color: #222222;
      line-height: 31px;
      margin-top: 0px;

      margin-left: 0px;
    }
  }

  &__description{
    font-family: Roboto, "sans-serif";
    font-weight: 300;
    font-size: 14px;
    color: #333942;
    line-height: 20px;
    margin-top: 13px;
  }

  &__alert{
    margin-top: 10px;
    margin-left: 12px;

    @include media(767){
      margin-left: 8px;
    }
  }

  &__input{
    margin-top: 20px;
  }

  &__classes{
    margin-top: 20px;
    display: flex;
    align-items: center;
  }

  &__classes-input{
    margin-left: 20px;
  }

  &__button{
    margin-top: 50px;
    margin-left: 8px;

  }

  &__classes-title{
    font-family: Roboto, "sans-serif";
    font-weight: 300;
    font-size: 15px;
    color: #333942;
    align-items: center;
  }


}
</style>
